import React, { Fragment } from 'react';
import axios from 'axios';
import { Languages } from '../components/languages';


export default class EbayWebAccessResult extends React.Component {
    constructor(props) {
        super(props);
        this.le = Languages.getSection("Ebay");

        const params = new URLSearchParams(window.location.search);
        this.state = {
            token: params.get('code')
        };

        setTimeout(() => {
            try {
                //alert(this.state.token);
                window.opener.handleEbayAccessResponse(this.state);
            }
            catch (e) {
                console.log("handleEbayAccessResponse exception.", e);
            }
        }, 500);
    }


    render() {

        return <div className="">
            {this.le.ok}
        </div>;

        /*

        if (this.state.code && this.state.state) {
            setTimeout(this.closeMe, 2000);
            return <div className="">
                {this.le.ok}
            </div>;
        }
        else {
            return <div className="">
                {this.le.ko}
            </div>;
        }
        
        let title = this.le.ko;

        return <div>
            {this.state.query}
        </div>;*/
        
    }
}

